import UFOSegment from '@atlaskit/react-ufo/segment';

import { GlobalFooter } from '@/patterns/global-footer/src/global-footer';
import { GlobalNav } from '@/patterns/global-nav/src/nav-global';
import { SearchTemplate } from '@/templates/search/search-page/src/search-template';

export const SearchResultsPage = () => {
	return (
		<UFOSegment name="search-page">
			<GlobalNav isShowTryNowLink={true} isShowSearchButton={false} productKey="search" />
			<SearchTemplate />
			<GlobalFooter />
		</UFOSegment>
	);
};
